import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Corporate from "../pages/corporate/page";
import College from "../pages/college/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/corporate-mice",
    element: <Corporate />,
  },
  {
    path: "/college-university",
    element: <College />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;